function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import Button from "../button";
import propTypes from "prop-types";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { MdLastPage, MdFirstPage } from "react-icons/md";
var PageButton = styled(Button)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.pagination.button;
});
var Page = function(param) {
    var active = param.active, label = param.label, onClick = param.onClick, disabled = param.disabled, testId = param.testId;
    return /*#__PURE__*/ React.createElement(PageButton, {
        className: "wr-base--pagination-page",
        disabled: disabled,
        small: true,
        onClick: onClick,
        outline: true,
        primary: Boolean(active),
        "data-testid": testId || "pagination-button__".concat(label)
    }, label);
};
Page.propTypes = {
    active: propTypes.bool.isRequired,
    label: propTypes.any.isRequired,
    onClick: propTypes.func.isRequired,
    disabled: propTypes.bool
};
var Pagination = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(Pagination, PureComponent);
    var _super = _createSuper(Pagination);
    function Pagination() {
        _classCallCheck(this, Pagination);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            currentPage: _this.props.firstPage || Pagination.defaultProps.firstPage
        };
        _this.handlePageChange = function(n) {
            if (n === _this.state.currentPage) {
                return;
            }
            _this.setState({
                currentPage: n
            });
            _this.props.onPageChange(n);
        };
        _this.renderPages = function() {
            var _loop = function(i) {
                var n = i + shift;
                if (n <= lastPage && n > 0) {
                    nodes.push(/*#__PURE__*/ React.createElement(Page, {
                        key: n,
                        active: n === currentPage,
                        label: n,
                        onClick: function() {
                            return _this.handlePageChange(n);
                        }
                    }));
                }
            };
            var _props = _this.props, pagesVisible = _props.pagesVisible, firstPage = _props.firstPage, lastPage = _props.lastPage, loading = _props.loading;
            if (loading) {
                return [
                    /*#__PURE__*/ React.createElement(Page, {
                        key: "placeholder",
                        label: "...",
                        onClick: function() {},
                        active: false
                    })
                ];
            }
            var currentPage = _this.state.currentPage;
            var _defaultProps = Pagination.defaultProps, defaultFirstPage = _defaultProps.firstPage, defaultPagesVisible = _defaultProps.pagesVisible;
            var nodes = [];
            var middlePage = Math.ceil((pagesVisible || defaultPagesVisible) / 2);
            var offset = (pagesVisible || defaultPagesVisible) - middlePage;
            var shift = currentPage - offset < (firstPage || defaultFirstPage) ? Math.abs((firstPage || defaultFirstPage) - (currentPage - offset)) : currentPage + offset > lastPage ? lastPage - (currentPage + offset) : 0;
            for(var i = currentPage - offset; i <= currentPage + offset; i++)_loop(i);
            return nodes;
        };
        _this.renderNavArrows = function(nodes) {
            var _props = _this.props, firstPage = _props.firstPage, lastPage = _props.lastPage;
            var currentPage = _this.state.currentPage;
            var _defaultProps = Pagination.defaultProps, defaultFirstPage = _defaultProps.firstPage;
            return [
                /*#__PURE__*/ React.createElement(Page, {
                    key: "firstPage",
                    label: /*#__PURE__*/ React.createElement(MdFirstPage, null),
                    active: true,
                    disabled: currentPage === firstPage,
                    onClick: function() {
                        return _this.handlePageChange(firstPage || defaultFirstPage);
                    },
                    testId: "pagination-first-page"
                }),
                /*#__PURE__*/ React.createElement(Page, {
                    key: "backPage",
                    label: /*#__PURE__*/ React.createElement(IoIosArrowBack, null),
                    active: true,
                    disabled: currentPage - 1 < (firstPage || defaultFirstPage),
                    onClick: function() {
                        return _this.handlePageChange(currentPage - 1);
                    },
                    testId: "pagination-back-page"
                }), 
            ].concat(_toConsumableArray(nodes), [
                /*#__PURE__*/ React.createElement(Page, {
                    key: "forwardPage",
                    label: /*#__PURE__*/ React.createElement(IoIosArrowForward, null),
                    active: true,
                    disabled: currentPage + 1 > lastPage,
                    onClick: function() {
                        return _this.handlePageChange(currentPage + 1);
                    },
                    testId: "pagination-next-page"
                }),
                /*#__PURE__*/ React.createElement(Page, {
                    key: "lastPage",
                    label: /*#__PURE__*/ React.createElement(MdLastPage, null),
                    active: true,
                    disabled: currentPage === lastPage,
                    onClick: function() {
                        return _this.handlePageChange(lastPage);
                    },
                    testId: "pagination-last-page"
                }), 
            ]);
        };
        return _this;
    }
    var _proto = Pagination.prototype;
    _proto.render = function render() {
        var withNavigationArrows = this.props.withNavigationArrows;
        return /*#__PURE__*/ React.createElement("div", {
            "data-testid": "pagination",
            className: "wr-base--pagination"
        }, withNavigationArrows ? this.renderNavArrows(this.renderPages()) : this.renderPages());
    };
    Pagination.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.hasOwnProperty("currentPage")) {
            if (state.currentPage > props.lastPage && !props.loading) {
                return {
                    currentPage: props.firstPage
                };
            } else if (props.currentPage !== state.currentPage) {
                return {
                    currentPage: props.currentPage
                };
            }
        }
        return null;
    };
    return Pagination;
}(PureComponent);
Pagination.propTypes = {
    lastPage: propTypes.number.isRequired,
    firstPage: propTypes.number,
    pagesVisible: propTypes.number,
    onPageChange: propTypes.func,
    withNavigationArrows: propTypes.bool,
    currentPage: propTypes.number,
    loading: propTypes.bool
};
Pagination.defaultProps = {
    firstPage: 1,
    pagesVisible: 5,
    onPageChange: function() {}
};
export default Pagination;
